import React, { useState, useEffect } from 'react';
import { Button, Typography, Box, useMediaQuery, Grid, Stack, CircularProgress } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { getSearchingResident, selectInvitationState } from "../../sagas/invitations/invitationSlice";
import { makeStyles } from "@mui/styles";
import { ResidentpageState } from '../../ResidentpageState';
import { SearchType, ResponseType } from '@inosio/payments-sdk';
import { InputField } from '../../../../components/InputController';
import ExtraLinks from './ExtraLinks';

interface PropsType {
  setPageState: React.Dispatch<React.SetStateAction<ResidentpageState>>,
  selectedProperty: any,
}

const useStyles = makeStyles({
  text: {
    fontFamily: 'Work Sans',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '18px',
    lineHeight: '21px',
    color: '#14142B',
  },
  buttonProgress: {
    color: "#053742",
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  }
});

export default function SearchResidentsByUuidAndName(props: PropsType) {
  const classes = useStyles();
  const matchesMobile = useMediaQuery("(max-width:380px)");

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const { propertyResponse } = useSelector(selectInvitationState);

  // Form Validation: start
  const [isValidForm, setIsValidForm] = useState(false);
  useEffect(() => {
    if (firstName && lastName) {
      setIsValidForm(true);
    } else {
      setIsValidForm(false);
    }
  }, [firstName, lastName])
  // Form Validation: end

  // Handle Submit: start
  const dispatch = useDispatch();
  const searchResidentByEmail = () => {
    dispatch(
      getSearchingResident({
        SearchType: SearchType.Name,
        PropertyUuid: props.selectedProperty.Uuid,
        FirstName: firstName,
        LastName: lastName,
        oneTimeUseToken: propertyResponse.oneTimeUseToken,
      })
    );
  }
  // Handle Submit: end

  // Check submission: start
  const { isSearchingResident, isSearchingResidentSucceed, residentResponse } = useSelector(selectInvitationState);
  useEffect(() => {
    if (isSearchingResidentSucceed && residentResponse?.ResponseType === ResponseType.Name && residentResponse?.residents?.length) {
      props.setPageState(ResidentpageState.SelectResident);
    }
  }, [isSearchingResidentSucceed, residentResponse])
  // Check submission: end

  return (
    <Stack direction='column' justifyContent='center' alignItems="center" spacing={4} sx={{ marginTop: '30px' }}>
      <Box sx={{ width: "200px" }}>
        <Typography className={classes.text} sx={{ textAlign: 'center' }}>
          Please enter your name
        </Typography>
      </Box>

      <Grid container direction="row" spacing={1} 
        sx={{ 
          marginTop: '10px !important',
          width: 'calc(100% + 8px)',
          marginRight: '8px !important',
        }}
      >
        <Grid item xs={12} sm={6}>
          <InputField
            name={"firstName"}
            label={"First Name"}
            placeholder={"First Name"}
            isError={false}
            onChange={(e) => setFirstName(e.target.value)}
            value={firstName}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputField
            name={"lastName"}
            label={"Last Name"}
            placeholder={"Last Name"}
            onChange={(e) => setLastName(e.target.value)}
            value={lastName}
          />
        </Grid>
      </Grid>

      <Stack 
        direction='row' 
        justifyContent='space-between' 
        alignItems="center" 
        sx={{ width: '100%', flexDirection: matchesMobile ? 'column': 'row', marginTop: '5px !important' }}
      >
        <Button
          variant="outlined"
          sx={{
            width: matchesMobile ? "100%": "183px",
            height: "49px",
            fontSize: '18px',
            borderRadius: "24px",
            textTransform: "none",
            color: "#39A2DB",
            transition: "background 0.55s, color 0.55s",
            borderColor: '#39A2DB',
            '&:hover': {
              backgroundColor: '#39A2DB',
              color: 'white',
              borderColor: '#39A2DB'
            }
          }}
          onClick={() => {props.setPageState(ResidentpageState.SearchResidentByEmail)}}
        >
          Search by email
        </Button>
        <Button
          type="submit"
          variant="contained"
          style={{
            width: matchesMobile ? "100%": "113px",
            marginTop: matchesMobile ? '20px': '',
            height: "49px",
            fontSize: '18px',
            borderRadius: "24px",
            textTransform: "capitalize",
            color: 'white',
            backgroundColor: isValidForm ? "#39A2DB" : "rgba(211, 211, 211, 1)",
            borderColor: isValidForm ? "#39A2DB" : "rgba(211, 211, 211, 1)",
          }}
          onClick={searchResidentByEmail}
          disabled={!isValidForm}
        >
          Search
          {isSearchingResident ? <CircularProgress size={26} className={classes.buttonProgress} /> : <></>}
        </Button>
      </Stack>

      <ExtraLinks />
    </Stack>
  )
}
